const React = require("react");
/*const auth = require("../../Authenticator.js");*/
const server = require("../../Server.js");


function getSPAFile(url) {
    return function() {
        server.Get(url).then((res) => {
            res.blob().then((blob) => {
                var url = window.URL.createObjectURL(blob);
                var a = window.document.createElement('a');
                a.href = url;
                a.download = "SPAFile.csv";
                a.click();  
            });
        });
    };
}

const SrPropertyAccountantAssignmentsForm = React.createClass({
    render() {
        return (<div>
            Senior Property Accountant store assignments file:&nbsp;
            <a href="javascript:void(0)" target="_blank" onClick={getSPAFile(this.props.SampleFileURL)}>Click here to download</a>
        </div>);
    }
});

module.exports = SrPropertyAccountantAssignmentsForm;


// WEBPACK FOOTER //
// ./src/components/metadata/SrPropertyAccountantAssignmentsForm.jsx